// React Composite View pattern 
// see https://github.com/mikayel/react-cv

//import $ from 'jquery';
import * as bootstrap from 'bootstrap-sass'

import React from 'react';
import ReactDOM from 'react'
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

import DataBus from './databus.js';
import SBDisclaimerConfig from './sbconfig.js';
import ResiDisclaimerConfig from './resiconfig.js';
import SheetData from './sheetdata.js';
import GoogleSheet from './googlesheet.js';

import Disclaimer from './pages/disclaimer/disclaimer';

import './css/main.scss';

//* DisclaimerApp exports to global 
const DisclaimerApp =  { 
		config : {}, 
		loadData :	() => {
			// * Google Sheets callback function 		
			// * old way - json feed with csv
			// SheetData.load(data)
		},
		loadSBGoogleSheet : () => {
			// * Google Sheets callback function 		
			// * new way - Sheets API v4 
			DisclaimerApp.config = SBDisclaimerConfig; 
			GoogleSheet.load(SBDisclaimerConfig, DataBus.setData)
		},
		loadResiGoogleSheet: () => {
			DisclaimerApp.config = ResiDisclaimerConfig;
			GoogleSheet.load(ResiDisclaimerConfig, DataBus.setData, DataBus.setUserSettings)
		}

}

const root = createRoot(document.getElementById('appWrapper'));
root.render(
    <BrowserRouter>
			<Routes>
				<Route path="/sb-disclaimer-tool/" element={<Disclaimer />} />
				<Route path="/resi-disclaimer-tool/" element={<Disclaimer />} />
			</Routes>
    </BrowserRouter>
);


export default DisclaimerApp;
